import { useNavigate } from "react-router-dom";
import Button from "../Button";
import CircleButton from "../CircleButton";
import DivideLine from "../DivideLine";
import ArrowRightIcon from "../Icon/ArrowRightIcon";
import PeopleIcon from "../Icon/PeopleIcon";
import PieIcon from "../Icon/PieIcon";
import CardsIcon from "../Icon/CardsIcon";
import TargetIcon from "../Icon/TargetIcon";
import styles from "./GroupItem.module.css";
import GroupProcess from "./GroupProcess";
import TapTooltip from "./TapTooltip";
import { useTranslation } from "react-i18next";
import { useGiftingGate } from "../../utils/giftingFlag";
import { markGiftStart } from "../../utils/giftIntent";
const GroupItem: React.FC<{
  groupInfo: any;
  fullDivider?: boolean;
}> = ({ groupInfo, fullDivider = false }) => {
  const navigate = useNavigate();
  const giftingGate = useGiftingGate();
  const { t } = useTranslation();
  // chunk 13 — formatted coverage multiplier (BR-PT comma); null when the API field is absent.
  const multiplierLabel =
    groupInfo.headlineMultiplier != null
      ? `${groupInfo.headlineMultiplier.toFixed(1).replace(".", ",")}×`
      : null;
  const tierLabel = groupInfo.minPrizeTier != null ? ` ${groupInfo.minPrizeTier}+` : "";
  return (
    <div>
      <div
        className={`${styles.GroupItem} ${fullDivider ? styles.m : styles.s}`}
      >
        <img
          className={`${styles.GroupItemIcon}`}
          src={groupInfo.game.imgUrl}
          alt={groupInfo.game.name || ""}
          width={50}
          height={50}
          loading="lazy"
          decoding="async"
        />
        <div className={styles.itemDetails}>
          <div className={styles.itemName}>{groupInfo.displayName}</div>
          <div className={styles.itemInfo}>
            {groupInfo.isFull ? (
              <span className={styles.pillFull}>Bolão completo</span>
            ) : (
              // Cluster 1 — fill: % + pie ring + hotness ramp glyph (chunk 13: the SignalIcon
              // bars were removed as a fill-% duplicate; the glyph now renders inline here).
              <span>
                {Math.round(groupInfo.percentage)}% <PieIcon />{" "}
                <GroupProcess percentage={groupInfo.percentage} />
              </span>
            )}
            {groupInfo.maxQuota != null && (
              <span style={{ width: "38px" }}>
                {groupInfo.maxQuota} <PeopleIcon />
              </span>
            )}
            {/* chunk 13 — jogos: # game-boards. Null-gated; absent on pre-backfill / single-game bolões. */}
            {groupInfo.jogoCount != null && (
              <TapTooltip title={`${groupInfo.jogoCount} jogos neste bolão`} style={{ width: "38px" }}>
                {groupInfo.jogoCount} <CardsIcon />
              </TapTooltip>
            )}
            {/* chunk 13 — coverage multiplier. Compact value on the card; the full framing
                stays in the tap tooltip. Gated independently of jogos. */}
            {multiplierLabel && (
              <TapTooltip
                title={`${multiplierLabel} mais chances de ganhar algum prêmio que uma aposta simples · não garante prêmio`}
              >
                <TargetIcon /> {multiplierLabel}{tierLabel}
              </TapTooltip>
            )}
          </div>
          {/* The caveat has to be legible without tapping, so it rides under the chip row
              rather than inside it — .itemInfo is a 12px wrap row and inline text there
              pushes the chips onto a second line. */}
          {multiplierLabel && (
            <div className={styles.multCaveat}>não garante prêmio</div>
          )}
        </div>
        {groupInfo.percentage < 100 ? (
          <div className={styles.itemButton}>
            {/* Hidden until the gate resolves to "on": a pop-in is the safe failure mode
                for an affordance (it simply appears a moment later). */}
            {giftingGate === "on" && (
              <CircleButton
                aria-label={t("gift.giftThis")}
                onClick={() => {
                  // "Start a gift" — route into the normal add flow; the recipient
                  // is entered at the cart (single source of truth). See STEP-0.
                  markGiftStart();
                  navigate(`/bolao/${groupInfo.groupId}`);
                }}
              >
                <span role="img" aria-hidden="true" className={styles.giftEmoji}>
                  🎁
                </span>
              </CircleButton>
            )}
            <CircleButton
              onClick={() => {
                navigate(`/bolao/${groupInfo.groupId}`);
              }}
            >
              <ArrowRightIcon size={"16px"} />
            </CircleButton>
          </div>
        ) : (
          <div className={styles.itemButton}>
            <Button type="disabled" width={"72px"} size="s">
              {t("groups.full")}
            </Button>
          </div>
        )}
      </div>
      <DivideLine padding={`${fullDivider ? "12px 0" : "8px 0 8px 58px"}`} />
    </div>
  );
};
export default GroupItem;
